if (!customElements.get('soodox-founder')) {
  customElements.define('soodox-founder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      this.querySelectorAll('[data-founder-open]').forEach(button => button.addEventListener('click', () => {
        dialog.showModal();
        video.src = video.dataset.videoUrl;
        video.play().catch(() => {});
      }));
      this.querySelector('[data-founder-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
    }
  });
}